import React, {useEffect, useState} from "react";
import TraderCard from "./components/TraderCard";
import SignalsCard from "./components/SignalsCard";
import { FaCrown, FaBell, FaTrophy } from "react-icons/fa6";
import TopTraders from "./components/TopTraders";
import ProfileService from "../../services/Profile";

const TopSignal = () => {
    const [loading, setLoading] = useState(false);
    const [traders, setTraders] = useState([]);

    useEffect(() => {
        const fetchTraders = async () => {
            try {
                const params = {
                    limit: 5,
                };
                const { data } = await ProfileService.getTopTraders(params);

                setTraders(data.data.docs);
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false);
            }
        };

        fetchTraders();
    }, []);

    return (
        <div className="bg-gradient-to-br from-slate-50 pb-10 via-purple-50 to-indigo-100 font-sans min-h-screen">
            {/* Header */}
            <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 flex items-center justify-center">
                            <FaTrophy className="text-yellow-500 text-2xl animate-spinY" />
                        </div>
                        <h1 className="text-2xl font-bold text-text-primary">Top</h1>
                    </div>
                    {/* <div className="flex items-center space-x-3">
                        <button
                            onClick={showAlarmSettings} 
                            className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors">
                            <FaBell className="text-orange-500" />
                        </button>
                    </div> */}
                </div>
            </header>
            {/* <header
                id="header"
                className="relative bg-gradient-to-r from-[#7c90e9] via-[#8B9FEB] to-[#9AAEEE] px-6 py-8 shadow-2xl"
            >
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="relative z-10">
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-4">
                            <div className="relative">
                                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                                    <FaCrown className="text-2xl text-yellow-300 animate-pulse" />
                                </div>
                                <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full animate-bounce"></div>
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold text-white">Top Performers</h1>
                                <p className="text-white/80 text-sm">
                                    Monthly Leaders &amp; Best Signals
                                </p>
                            </div>
                        </div>

                        <button className="relative w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-white/30 transition-all">
                            <FaBell className="text-white text-lg" />
                            <div className="absolute top-2 right-2 w-2 h-2 bg-red-400 rounded-full animate-ping"></div>
                        </button>
                    </div>
                </div>
            </header> */}

            {/* Main Content */}
            <main className="pt-3 space-y-4 mb-12 mt-16">
                <TopTraders />
                <TraderCard traders={traders} />
                <SignalsCard />
            </main>
        </div>
    );
};

export default TopSignal;





//
// import NotifIco from "../../assets/svgs/Notif"
// import prof1 from "./image/test.jpg"
// import Anonymous from './image/anonymous.jpg.webp'
//
// import { Navigate, useNavigate } from "react-router-dom";
// import { useEffect,useContext } from "react";
// import { SafeAreaContext } from "../../App";
// import { IoMdNotifications } from "react-icons/io";
// import { FaTrophy } from "react-icons/fa6";
// import { FaStar } from "react-icons/fa6";
//
// import { FaCrown } from "react-icons/fa6";
// import TraderCard from "./components/TraderCard";
// import SignalsCard from "./components/SignalsCard";
//
// export default function TopSignal(){
// //safArea for Pwa////////
// const { setSafeAreaColor } = useContext(SafeAreaContext);
//
// useEffect(() => {
//     setSafeAreaColor({ background: "#FFFFFF" });
// }, []);
// ////////////////////////
//     const navigation=useNavigate()
//     function onLastSignalClick(){
//
//         navigation('/lastSignals')
//     }
//     return(
//         <>
//
//         <div className="bg-light min-h-screen  scrollbar-hide   w-full ">
//             {/* header */}
//             <header className="bg-white px-4 py-4 shadow-md">
//
//                 <div className="flex items-center justify-between">
//
//                     <div className="flex items-center space-x-3">
//                         <div className="nav-icon text-2xl flex items-center justify-center w-8 h-8 relative">
//
//                             <FaCrown className="text-yellow-400 size-7 drop-shadow animate-crown-glow" />
//                             <div className="absolute -top-[2px] -left-[2px]  text-yellow-400 text-[0.5rem]  animate-sparkle ">
//                             ✨
//                             </div>
//                             <div className="absolute -top-[2px] -right-[2px]  text-yellow-400 text-[0.5rem]  delay-200 animate-sparkle [animation-delay:0.5s]">
//                             ⭐
//                             </div>
//                             <div className="absolute bottom-0  -translate-x-1/2 text-yellow-400 text-[0.5rem] delay-500 animate-sparkle [animation-delay:1,0s]">
//                             💎
//                             </div>
//                         </div>
//                         <h1 className="text-2xl font-extrabold text-gray-900 ">
//                             Top Signals & Traders
//                         </h1>
//                     </div>
//
//
//                     <div className="flex items-center space-x-3">
//                         <button className="flex h-10 w-10 items-center justify-center rounded-xl bg-orange-50 hover:bg-orange-100 transition-colors">
//                             <IoMdNotifications className="text-orange-500 size-5" />
//                         </button>
//                     </div>
//
//                 </div>
//             </header>
//             {/* header */}
//             {/* body */}
//             <main className="overflow-y-hidden flex-1 pb-20   ">
//
//                 <div className="flex flex-col w-full  items-center justify-start gap-4 px-5 py-6 pt-8 " >
//
//                     {/* header of body */}
//                         <div className="flex flex-row w-full items-center justify-between ">
//                                <div className="flex items-center">
//                                    <div className="text-2xl mr-3 relative">
//                                        <FaTrophy className="fas fa-trophy size-7 text-yellow-500"></FaTrophy>
//                                        <div className="absolute -top-1 -right-1 w-2 h-2 bg-yellow-400 rounded-full animate-ping"></div>
//                                    </div>
//                                    <h3 className="text-xl font-extrabold text-dark">Top Traders This Month</h3>
//                                </div>
//
//                                <button  className="text-primary text-sm font-bold hover:(text-decoration-line:underline)">
//                                    View All
//                                </button>
//                         </div>
//                         {/* header of body */}
//
//                         <div className="flex flex-col overflow-y-auto w-full gap-4 max-h-[calc((5*130px)+18px)]  rounded-lg  ">
//
//                             <TraderCard></TraderCard>
//                             <TraderCard></TraderCard>
//                             <TraderCard></TraderCard>
//                             <TraderCard></TraderCard>
//                             <TraderCard></TraderCard>
//                             <TraderCard></TraderCard>
//                         </div>
//
//                 </div>
//
//                 {/* best signals */}
//                 <div className="flex flex-col w-full items-center justify-start gap-4 px-5 py-6    bg-gray-100" >
//
//                         <div className="flex items-center justify-between mb-2 w-full ">
//                                 <div className="flex items-center">
//                                     <div className="text-2xl mr-3 relative">
//                                         <FaStar className="fas fa-star bg-transparent text-yellow-500 size-7 animate-pulse"></FaStar>
//                                         <div className="absolute -top-1 -right-1 w-2 h-2 bg-orange-400 rounded-full animate-bounce"></div>
//                                     </div>
//                                     <h3 className="text-xl font-bold text-dark">Top Signals This Month</h3>
//                                 </div>
//
//                                 <button id="view-all-signals" className="text-primary text-sm font-semibold hover:underline">
//                                     View All
//                                 </button>
//                         </div>
//
//                         <div className="flex flex-col overflow-y-auto w-full gap-4 max-h-[calc((3*195px)+12px)]    ">
//
//                             <SignalsCard></SignalsCard>
//                             <SignalsCard></SignalsCard>
//                             <SignalsCard></SignalsCard>
//                             <SignalsCard></SignalsCard>
//                             <SignalsCard></SignalsCard>
//
//
//                         </div>
//
//                 </div>
//                 {/* best signals */}
//                 </main>
//
//
//             {/* body */}
//          </div>
//
//         </>
//     )
// }